import React from 'react'
import PropTypes from 'prop-types'

const Select = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    onBlur,
    label,
    children,
    disabled = false,
    className,
  } = props

  const handleChange = (event) => {
    onChange(event)
  }

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const finalId = id || name

  return (
    <div className='field field-select'>
      <select
        id={finalId}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        className={className || 'select'}
        value={value}
        disabled={disabled}
      >
        {children}
      </select>

      {label && (
        <label htmlFor={finalId} className='label'>
          {label}
        </label>
      )}
    </div>
  )
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,

  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),

  children: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default Select
